import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-switch',
  templateUrl: './formly-switch.component.html',
  styleUrls: ['./formly-switch.component.scss']
})
export class FormlySwitchComponent extends FieldType {}
